import React from 'react'
import { connect } from 'react-redux'
import init from './init'


const MACHINE_DISTANCE_THRESHOLD = 0.47

const Result = (props) => {
    let outcome = null
    if (props.correctForHuman > props.correctForMachine) {
        outcome = 'beat'
    } else if (props.correctForHuman < props.correctForMachine) {
        outcome = 'lose to'
    } else {
        outcome = 'are on equal ground with'
    }

    return (
        <div className='callout success'>
            <p>Here is your result.</p>
            <h5><p>You { outcome } the machine.</p></h5>
            <div>You: { props.correctForHuman } / { props.total }</div>
            <div>Machine: { props.correctForMachine } / { props.total }</div>
            <button className='button' onClick={ init }>Start Over</button>
        </div>
    )
}

const mapStateToProps = (state) => {
    const results = state.results
    const total = results.length
    const correctForHuman = results.filter(r => r.response === r.match).length
    const correctForMachine = results.filter(r => (r.responseFromMachine < MACHINE_DISTANCE_THRESHOLD) === r.match).length

    return {
          correctForHuman
        , correctForMachine
        , total
    }
}

export default connect(mapStateToProps)(Result)



// WEBPACK FOOTER //
// ./src/Result.js